import React from "react";
import {
  SFStack,
  SFTypography,
  SFButton,
  SFUseStyled,
  SFIcons,
} from "@sf-core";
import UserProfileAvatar from "./components/userProfileAvatar";

const { styled } = SFUseStyled();

const StyledSFStack = styled(SFStack)(({ theme }) => ({
  paddingTop: theme.spacing(8),
}));

const StyledSFButton = styled(SFButton)(({ theme, disabled }) => ({
  ...(disabled && {
    backgroundColor: theme.palette.grey400.main + "!important",
    borderColor: theme.palette.grey400.main + "!important",
    color: theme.palette.grey350.main + "!important",
  }),
}));

const Container = styled("div", {
  shouldForwardProp: (prop) =>
    prop !== "hideScrollBar" && prop !== "hasLargeHeader",
})(({ theme, hideScrollBar, hasLargeHeader }) => ({
  width: "100%",
  maxHeight: "47vh",
  overflowY: "auto",
  overflowX: "hidden",
  minWidth: "400px",
  ...(hideScrollBar && {
    "&::-webkit-scrollbar": {
      display: "none",
    },
  }),
  ...(hasLargeHeader && {
    maxHeight: "40vh",
  }),
}));

const StepContainer = ({
  stepTitle,
  stepDescription,
  header,
  children,
  onTransparentButtonClick = () => {},
  transparentButtonLabel,
  onSecondaryButtonClick = () => {},
  secondaryButtonLabel,
  stepCompleted = false,
  hideScrollBar = false,
  disableFrontButton = false,
  hasLargeHeader = false,
  showTransparentButton = true,
}) => {
  return (
    <StyledSFStack direction="row" justifyContent="center" spacing={8}>
      <SFStack direction="column" spacing={2}>
        <SFStack direction="column" justifyContent="flex-start" spacing={1}>
          <SFTypography variant={"academyCardTitle"}>{stepTitle}</SFTypography>
          <SFTypography variant={"body2"}>{stepDescription}</SFTypography>
        </SFStack>
        <SFStack direction="column" spacing={4}>
          {header}
          <Container
            hideScrollBar={hideScrollBar}
            hasLargeHeader={hasLargeHeader}
          >
            {children}
          </Container>
          <SFStack direction="row" spacing={1}>
            {showTransparentButton && (
              <SFButton
                variant="transparent"
                onClick={() => onTransparentButtonClick()}
              >
                {transparentButtonLabel}
              </SFButton>
            )}
            <StyledSFButton
              startIcon={<SFIcons.SFCheckIcon />}
              variant="secondary"
              onClick={() => onSecondaryButtonClick()}
              disabled={disableFrontButton}
            >
              {secondaryButtonLabel}
            </StyledSFButton>
          </SFStack>
        </SFStack>
      </SFStack>

      <UserProfileAvatar complete={stepCompleted} />
    </StyledSFStack>
  );
};

export default StepContainer;
